import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PipesModule } from "../../../../pipes/pipes.module";

@Component({
    selector: 'datatable-progress',
    template: `
    <div class="progress-linear"
         role="progressbar"
         aria-live="polite"
         aria-label="progress bar"
         [attr.aria-valuenow]="0"
         [attr.aria-valuemin]="0"
         [attr.aria-valuemax]="100"
         [attr.aria-valuetext]="'tdWb.loading.LOADING' | tdWbTranslate">
      <div class="container">
        <div class="bar"></div>
      </div>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        PipesModule
    ]
})
export class ProgressBarComponent {}
